'use client';
import { useState, useEffect } from 'react';
import { isWindowDefined } from '@utils/validations';

const useIsScrollTopOfPage = () => {
  const [isScrollTopOfPage, setIsScrollTopOfPage] = useState(isWindowDefined && window?.scrollY === 0);

  useEffect(() => {
    if (!isWindowDefined) {
      return;
    }

    function onScroll() {
      setIsScrollTopOfPage(window?.scrollY === 0);
    }

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return isScrollTopOfPage;
};

export default useIsScrollTopOfPage;
